// extracted by mini-css-extract-plugin
export var lg = "_1f-4";
export var md = "_1f-3";
export var sm = "_1f-2";
export var xs = "_1f-1";
export var xxs = "_1f-0";